import { render, staticRenderFns } from "./Factory-order-myself.vue?vue&type=template&id=541cb57c&scoped=true&"
import script from "./Factory-order-myself.vue?vue&type=script&lang=js&"
export * from "./Factory-order-myself.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541cb57c",
  null
  
)

export default component.exports